import { useAppSelector } from '@/hooks/storeHooks';

const useServicePartner = () => {
  const servicePartner = useAppSelector(({ app }) => app.servicePartner);
  return servicePartner;
};

export default useServicePartner;
